import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './auth/guards/auth.guard';
import { AuthService } from './auth/services/auth.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoaderService } from './auth/services/loader.service';
import { ToastrModule } from 'ngx-toastr';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TokenInterceptorService } from './auth/services/token-interceptor.service';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { LoaderInterceptorService } from './core/services/loader-interceptor.service';
import { SharedModule } from './shared/shared.module';
import { NgApexchartsModule } from 'ng-apexcharts';
import { BookingReportComponent } from './booking-report/booking-report.component';


@NgModule({
  declarations: [
    AppComponent,
    BookingReportComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    NgApexchartsModule,
    ToastrModule.forRoot(
      {
        // timeOut: 10000000000,
        positionClass: 'toast-top-center',
        preventDuplicates: true,
      }
    )

  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptorService, multi: true },
    { provide: LOCALE_ID, useValue: "en-US" },
    AuthService,
    AuthGuard,
  ],
  exports: [
    TypeaheadModule,
  ],


  bootstrap: [AppComponent],
})
export class AppModule { }
